import { Button } from 'react-bootstrap';
import styled from 'styled-components';

const StyledLinkButton = styled(Button)`
  color: ${(props) => props.theme.colors.light};
  font-weight: 500;
  text-decoration: none;
`;

export default StyledLinkButton;
